import { createFileRoute } from "@tanstack/react-router"
import { procedureTypeSettingsViewStaticData } from "src/views/ProcedureTypeSettingsView/constants"
import { ProcedureTypeSettingsView } from "src/views/ProcedureTypeSettingsView/ProcedureTypeSettingsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/procedure-types/")({
	component: ProcedureTypeSettingsView,
	staticData: procedureTypeSettingsViewStaticData,
})
